import { useQueryClient } from '@tanstack/react-query';
import React from 'react';

import { useSocketStore } from '../../store/useSocketStore';
import { queryKeys } from '../../queryKeys';

export function useScheduleSocket() {
  const { socket } = useSocketStore();
  const queryClient = useQueryClient();

  React.useEffect(() => {
    if (!socket) return;

    const invalidateSchedule = () => {
      queryClient.invalidateQueries({
        exact: false,
        queryKey: queryKeys.schedule.fetchSchedule._def,
      });
    };

    socket.on('schedule:added', invalidateSchedule);
    socket.on('schedule:updated', invalidateSchedule);
    socket.on('schedule:deleted', invalidateSchedule);

    return () => {
      socket.off('schedule:added', invalidateSchedule);
      socket.off('schedule:updated', invalidateSchedule);
      socket.off('schedule:deleted', invalidateSchedule);
    };
  }, [socket, queryClient]);
}
